import { useState, useEffect } from 'react'

// ─── Données semaine 1 ────────────────────────────────────
const WEEK1 = [
  // LUNDI
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-07:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"07:00-10:00",title:"Johnny Réveil",cat:"Emission"},
    {t:"10:00-12:00",title:"Les années 60",cat:"Années"},
    {t:"12:00-14:00",title:"Johnny Love",cat:"Emission"},
    {t:"14:00-17:00",title:"Johnny Drive",cat:"Emission"},
    {t:"17:00-19:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"19:00-21:00",title:"Live Expérience",cat:"Emission"},
    {t:"21:00-23:00",title:"Johnny Story",cat:"Emission"},
    {t:"23:00-23:59",title:"Les années 1960 - 2017",cat:"Années"},
  ],
  // MARDI
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-07:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"07:00-10:00",title:"Johnny Réveil",cat:"Emission"},
    {t:"10:00-12:00",title:"Les années 70",cat:"Années"},
    {t:"12:00-14:00",title:"Johnny Love",cat:"Emission"},
    {t:"14:00-17:00",title:"Johnny Drive",cat:"Emission"},
    {t:"17:00-19:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"19:00-21:00",title:"Live Expérience",cat:"Emission"},
    {t:"21:00-23:00",title:"Johnny Story",cat:"Emission"},
    {t:"23:00-00:00",title:"Johnny 51",cat:"Emission"},
  ],
  // MERCREDI
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-07:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"07:00-10:00",title:"Johnny Réveil",cat:"Emission"},
    {t:"10:00-12:00",title:"Les années 80",cat:"Années"},
    {t:"12:00-14:00",title:"Johnny Love",cat:"Emission"},
    {t:"14:00-17:00",title:"Johnny Drive",cat:"Emission"},
    {t:"17:00-19:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"19:00-21:00",title:"Live Expérience",cat:"Emission"},
    {t:"21:00-23:00",title:"Johnny Story",cat:"Emission"},
    {t:"23:00-23:59",title:"Les années 1960 - 2017",cat:"Années"},
  ],
  // JEUDI
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-07:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"07:00-10:00",title:"Johnny Réveil",cat:"Emission"},
    {t:"10:00-12:00",title:"Les années 90",cat:"Années"},
    {t:"12:00-14:00",title:"Johnny Love",cat:"Emission"},
    {t:"14:00-17:00",title:"Johnny Drive",cat:"Emission"},
    {t:"17:00-19:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"19:00-21:00",title:"Live Expérience",cat:"Emission"},
    {t:"21:00-23:00",title:"Johnny Story",cat:"Emission"},
    {t:"23:00-00:00",title:"Johnny 51",cat:"Emission"},
  ],
  // VENDREDI
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-07:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"07:00-10:00",title:"Johnny Réveil",cat:"Emission"},
    {t:"10:00-12:00",title:"Les années 2000 - 2010",cat:"Années"},
    {t:"12:00-14:00",title:"Johnny Love",cat:"Emission"},
    {t:"14:00-17:00",title:"Johnny Drive",cat:"Emission"},
    {t:"17:00-19:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"19:00-21:00",title:"Live Expérience",cat:"Emission"},
    {t:"21:00-23:00",title:"Johnny Story",cat:"Emission"},
    {t:"23:00-23:59",title:"Les années 1960 - 2017",cat:"Années"},
  ],
  // SAMEDI
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-08:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"08:00-12:00",title:"Johnny Héritage",cat:"Emission"},
    {t:"12:00-12:30",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"12:30-13:30",title:"Johnny Cinéma",cat:"Emission"},
    {t:"13:30-14:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"14:00-16:00",title:"Johnny Collector",cat:"Emission"},
    {t:"16:00-18:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"18:00-20:00",title:"Salut les Copains",cat:"Emission",presenter:"David"},
    {t:"20:00-21:00",title:"Johnny Bakstage",cat:"Emission"},
    {t:"21:00-23:59",title:"Johnny Intime",cat:"Emission"},
  ],
  // DIMANCHE
  [
    {t:"00:00-03:00",title:"Johnny Nuit",cat:"Emission"},
    {t:"03:00-08:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"08:00-12:00",title:"Johnny Héritage",cat:"Emission"},
    {t:"12:00-12:30",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"12:30-13:30",title:"Johnny Cinéma",cat:"Emission"},
    {t:"13:30-14:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"14:00-16:00",title:"Johnny de A à Z",cat:"Emission"},
    {t:"16:00-20:00",title:"Les années 1960 - 2017",cat:"Années"},
    {t:"20:00-21:00",title:"Johnny Bakstage",cat:"Emission"},
    {t:"21:00-23:59",title:"Johnny Intime",cat:"Emission"},
  ],
]

const WEEK2 = WEEK1 // identique chaque semaine, pas d'alternance

// ─── Config catégories ────────────────────────────────────
const CAT = {
  Concert:  { color: '#00d9ff', bg: 'rgba(0,217,255,0.12)',  border: 'rgba(0,217,255,0.35)',  icon: '🎵' },
  Années:   { color: '#a78bfa', bg: 'rgba(167,139,250,0.12)', border: 'rgba(167,139,250,0.35)', icon: '💿' },
  History:  { color: '#fbbf24', bg: 'rgba(251,191,36,0.12)', border: 'rgba(251,191,36,0.35)', icon: '📜' },
  Spécial:  { color: '#f472b6', bg: 'rgba(244,114,182,0.12)', border: 'rgba(244,114,182,0.35)', icon: '⭐' },
  Emission: { color: '#34d399', bg: 'rgba(52,211,153,0.12)', border: 'rgba(52,211,153,0.35)', icon: '🎙' },
  Studio:   { color: '#ffd700', bg: 'rgba(255,215,0,0.10)',  border: 'rgba(255,215,0,0.3)',   icon: '📻' },
}
const getCat = c => CAT[c] || CAT.Studio

// ─── Helpers ─────────────────────────────────────────────
const REFERENCE = new Date(2025, 3, 14)
const DAY_SHORT  = ['Dim.','Lun.','Mar.','Mer.','Jeu.','Ven.','Sam.']
const DAY_FULL   = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi']
const MONTH_FR   = ['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.']

function getWeekIndex(date) {
  const diff = Math.floor((date - REFERENCE) / 86400000)
  return Math.floor(diff / 7) % 2
}

function getMondayOfWeek(date) {
  const d = new Date(date)
  const dow = d.getDay()
  d.setDate(d.getDate() - (dow === 0 ? 6 : dow - 1))
  d.setHours(0,0,0,0)
  return d
}

function getWeekDates(date) {
  const mon = getMondayOfWeek(date)
  return Array.from({length:7}, (_,i) => {
    const d = new Date(mon)
    d.setDate(mon.getDate() + i)
    return d
  })
}

function isToday(date) {
  const t = new Date()
  return date.getDate() === t.getDate() && date.getMonth() === t.getMonth() && date.getFullYear() === t.getFullYear()
}

function timeToMinutes(str) {
  const [h, m] = str.split(':').map(Number)
  return h * 60 + m
}

function getCurrentProgram(programs) {
  const now = new Date()
  const cur = now.getHours() * 60 + now.getMinutes()
  return programs.find(p => {
    const [s, e] = p.t.split('-').map(timeToMinutes)
    if (e < s) return cur >= s || cur < e
    return cur >= s && cur < e
  }) || null
}

function getPrograms(date) {
  const dow = date.getDay()
  const idx = dow === 0 ? 6 : dow - 1
  return (getWeekIndex(date) === 0 ? WEEK1 : WEEK2)[idx] || []
}

function formatWeekRange(date) {
  const dates = getWeekDates(date)
  const s = dates[0], e = dates[6]
  return `${s.getDate()} ${MONTH_FR[s.getMonth()]} – ${e.getDate()} ${MONTH_FR[e.getMonth()]} ${e.getFullYear()}`
}

// ─── Composant principal ──────────────────────────────────
export default function PlanningPage() {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [now, setNow] = useState(new Date())
  const [showInfo, setShowInfo] = useState(false)
  const [search, setSearch] = useState('')

  useEffect(() => {
    const iv = setInterval(() => setNow(new Date()), 30000)
    return () => clearInterval(iv)
  }, [])

  const weekDates  = getWeekDates(selectedDate)
  const programs   = getPrograms(selectedDate)
  const current    = isToday(selectedDate) ? getCurrentProgram(programs) : null

  // Résumé catégories
  const summary = programs.reduce((acc, p) => {
    acc[p.cat] = (acc[p.cat] || 0) + 1; return acc
  }, {})

  // Filtre recherche
  const filtered = search
    ? programs.filter(p => p.title.toLowerCase().includes(search.toLowerCase()) || p.cat.toLowerCase().includes(search.toLowerCase()))
    : programs

  return (
    <div className="page active">
      <div style={{ maxWidth: '100%', width: '100%', padding: 'clamp(12px,2vw,24px)', paddingBottom: 80, boxSizing: 'border-box' }}>

        {/* HEADER */}
        <div className="page-header" style={{ marginBottom: 'clamp(14px,2.5vh,22px)' }}>
          <div className="page-badge">📺 PLANNING</div>
          <h1 className="page-title">Planning Radio</h1>
          <p className="page-subtitle">Programme complet 24h/24 – 7j/7</p>
        </div>

        {/* WIDGET PLANNING */}
        <div className="glass-card" style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(12px,2vh,18px)' }}>

          {/* En-tête semaine + bouton info */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
            <div>
              <div style={{ fontWeight: 800, fontSize: 'clamp(1rem,2.2vw,1.2rem)', color: '#fff' }}>
                Semaine du {formatWeekRange(selectedDate)}
              </div>
              <div style={{ fontSize: 'clamp(0.78rem,1.5vw,0.88rem)', color: 'rgba(255,255,255,0.5)', marginTop: 3 }}>
                Planning hebdomadaire · Semaine {getWeekIndex(selectedDate) + 1}
              </div>
            </div>
            <button
              onClick={() => setShowInfo(v => !v)}
              style={{
                display: 'flex', alignItems: 'center', gap: 7,
                padding: 'clamp(8px,1.4vh,11px) clamp(14px,2vw,18px)',
                background: 'rgba(0,217,255,0.12)', border: '1px solid rgba(0,217,255,0.3)',
                borderRadius: 12, color: '#00d9ff', fontWeight: 700,
                fontSize: 'clamp(0.8rem,1.5vw,0.88rem)', cursor: 'pointer', outline: 'none'
              }}
            >
              ℹ️ Information
            </button>
          </div>

          {/* Modal info */}
          {showInfo && (
            <div style={{ padding: 'clamp(14px,2.5vh,18px)', background: 'rgba(0,217,255,0.07)', border: '1px solid rgba(0,217,255,0.25)', borderRadius: 14 }}>
              <div style={{ fontWeight: 800, fontSize: 'clamp(0.95rem,1.9vw,1.05rem)', marginBottom: 10, color: '#00d9ff' }}>
                📢 Informations
              </div>
              {[
                '🗞️ Flash Info (Tous les jours) 08H00 et 12H00',
                '🌤️ Météo (Tous les jours) 08H00',
                '⭐ Horoscope (Tous les jours) 06H00',
                '🎬 Chronique Cinéma (Mercredi) 14H00',
                '⚽ Chronique Sport (Lundi au Samedi) 16H30 — (Dimanche) 14H00',
              ].map((line, i) => (
                <div key={i} style={{ fontSize: 'clamp(0.82rem,1.6vw,0.92rem)', color: 'rgba(255,255,255,0.82)', padding: '5px 0', borderBottom: i < 4 ? '1px solid rgba(255,255,255,0.06)' : 'none' }}>
                  {line}
                </div>
              ))}
              <button onClick={() => setShowInfo(false)} style={{ marginTop: 12, background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: '0.82rem' }}>
                ✕ Fermer
              </button>
            </div>
          )}

          {/* Sélecteur de dates */}
          <div style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 4, scrollbarWidth: 'none' }}>
            {weekDates.map((date, i) => {
              const sel = date.toDateString() === selectedDate.toDateString()
              const tod = isToday(date)
              return (
                <button
                  key={i}
                  onClick={() => setSelectedDate(date)}
                  style={{
                    flexShrink: 0,
                    minWidth: 'clamp(48px,10vw,62px)',
                    padding: 'clamp(8px,1.4vh,11px) clamp(6px,1vw,10px)',
                    background: sel ? 'linear-gradient(135deg,#00d9ff,#ffd700)' : tod ? 'rgba(255,215,0,0.1)' : 'rgba(255,255,255,0.05)',
                    border: sel ? 'none' : tod ? '1px solid rgba(255,215,0,0.4)' : '1px solid rgba(255,255,255,0.1)',
                    borderRadius: 12, cursor: 'pointer', outline: 'none',
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
                    transition: 'all 0.2s'
                  }}
                >
                  <div style={{ fontSize: 'clamp(0.62rem,1.2vw,0.72rem)', fontWeight: 700, color: sel ? '#000' : 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {DAY_SHORT[date.getDay()]}
                  </div>
                  <div style={{ fontSize: 'clamp(1rem,2.5vw,1.3rem)', fontWeight: 900, color: sel ? '#000' : tod ? '#ffd700' : '#fff' }}>
                    {date.getDate()}
                  </div>
                  {tod && !sel && <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#ffd700' }} />}
                </button>
              )
            })}
          </div>

          {/* EN DIRECT */}
          {current && (
            <div style={{
              padding: 'clamp(12px,2vh,16px)', borderRadius: 14,
              background: 'linear-gradient(135deg,rgba(0,217,255,0.15),rgba(255,215,0,0.1))',
              border: '2px solid rgba(0,217,255,0.4)',
              display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#00d9ff', animation: 'pulse 1.5s infinite', boxShadow: '0 0 10px #00d9ff' }} />
                <span style={{ fontWeight: 800, color: '#00d9ff', fontSize: 'clamp(0.72rem,1.4vw,0.82rem)', textTransform: 'uppercase', letterSpacing: '1px' }}>
                  En direct
                </span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 800, fontSize: 'clamp(0.92rem,1.9vw,1.05rem)', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {current.title}
                </div>
                {current.presenter && (
                  <div style={{ fontSize: 'clamp(0.65rem,1.2vw,0.75rem)', color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', marginTop: 1 }}>
                    Présenté par {current.presenter}
                  </div>
                )}
                <div style={{ fontSize: 'clamp(0.72rem,1.4vw,0.82rem)', color: 'rgba(255,255,255,0.55)', marginTop: 2 }}>
                  {current.t.replace('-',' → ')}
                </div>
              </div>
              <span style={{ padding: '4px 10px', borderRadius: 8, fontSize: '0.72rem', fontWeight: 700, background: getCat(current.cat).bg, border: `1px solid ${getCat(current.cat).border}`, color: getCat(current.cat).color, flexShrink: 0 }}>
                {getCat(current.cat).icon} {current.cat}
              </span>
            </div>
          )}

          {/* Résumé catégories */}
          <div>
            <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.4)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 8 }}>
              Résumé du jour · {programs.length} émissions
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {Object.entries(summary).map(([cat, count]) => {
                const c = getCat(cat)
                return (
                  <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '5px 10px', borderRadius: 9, background: c.bg, border: `1px solid ${c.border}` }}>
                    <span style={{ fontSize: '0.75rem' }}>{c.icon}</span>
                    <span style={{ color: c.color, fontWeight: 700, fontSize: 'clamp(0.68rem,1.3vw,0.78rem)' }}>{cat}: {count}</span>
                  </div>
                )
              })}
            </div>
          </div>

          {/* Recherche */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 'clamp(8px,1.5vh,12px) clamp(12px,2vw,16px)', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12 }}>
            <span style={{ fontSize: '1rem', flexShrink: 0 }}>🔍</span>
            <input
              type="text"
              placeholder="Rechercher une émission..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ flex: 1, background: 'transparent', border: 'none', color: '#fff', outline: 'none', fontSize: 'clamp(0.85rem,1.7vw,0.95rem)' }}
            />
            {search && <button onClick={() => setSearch('')} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.45)', cursor: 'pointer', fontSize: '1rem' }}>✕</button>}
          </div>

          {/* Titre du jour */}
          <div style={{ fontWeight: 800, fontSize: 'clamp(0.95rem,2vw,1.1rem)', color: 'rgba(255,255,255,0.7)' }}>
            {DAY_FULL[selectedDate.getDay()]} {selectedDate.getDate()} {MONTH_FR[selectedDate.getMonth()]}
          </div>

          {/* LISTE DES PROGRAMMES */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {filtered.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: 'rgba(255,255,255,0.4)', fontSize: '0.95rem' }}>
                Aucune émission trouvée
              </div>
            ) : filtered.map((prog, i) => {
              const c   = getCat(prog.cat)
              const cur = current === prog

              return (
                <div
                  key={i}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 'clamp(8px,1.5vw,14px)',
                    padding: 'clamp(10px,1.8vh,14px) clamp(12px,2vw,16px)',
                    background: cur
                      ? 'linear-gradient(135deg,rgba(0,217,255,0.15),rgba(255,215,0,0.1))'
                      : 'rgba(255,255,255,0.03)',
                    border: `1px solid ${cur ? 'rgba(0,217,255,0.5)' : c.border}`,
                    borderRadius: 12, transition: 'all 0.2s',
                    borderLeft: `3px solid ${c.color}`,
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  {/* Icône catégorie */}
                  <div style={{
                    width: 'clamp(32px,6vw,42px)', height: 'clamp(32px,6vw,42px)', borderRadius: 10,
                    background: c.bg, border: `1px solid ${c.border}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 'clamp(0.9rem,2vw,1.1rem)', flexShrink: 0
                  }}>
                    {c.icon}
                  </div>

                  {/* Heure */}
                  <div style={{ flexShrink: 0, minWidth: 'clamp(80px,14vw,110px)', fontVariantNumeric: 'tabular-nums' }}>
                    <div style={{ fontWeight: 700, fontSize: 'clamp(0.75rem,1.5vw,0.88rem)', color: c.color }}>
                      {prog.t.split('-')[0]}
                    </div>
                    <div style={{ fontSize: 'clamp(0.65rem,1.2vw,0.75rem)', color: 'rgba(255,255,255,0.35)' }}>
                      → {prog.t.split('-')[1]}
                    </div>
                  </div>

                  {/* Titre + badge */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: cur ? 800 : 600, fontSize: 'clamp(0.85rem,1.7vw,0.98rem)', color: cur ? '#fff' : 'rgba(255,255,255,0.88)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {cur && <span style={{ marginRight: 6 }}>▶</span>}
                      {prog.title}
                    </div>
                    {prog.presenter && (
                      <div style={{ fontSize: 'clamp(0.6rem,1.1vw,0.7rem)', color: 'rgba(255,255,255,0.4)', fontStyle: 'italic', marginTop: 1 }}>
                        Présenté par {prog.presenter}
                      </div>
                    )}
                    <span style={{ display: 'inline-block', marginTop: 3, padding: '2px 8px', borderRadius: 6, fontSize: 'clamp(0.6rem,1.1vw,0.7rem)', fontWeight: 700, background: c.bg, color: c.color }}>
                      {prog.cat}
                    </span>
                  </div>

                  {/* Badge EN DIRECT */}
                  {cur && (
                    <div style={{ flexShrink: 0, padding: '4px 10px', borderRadius: 8, background: 'rgba(0,217,255,0.2)', border: '1px solid rgba(0,217,255,0.5)', color: '#00d9ff', fontWeight: 800, fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Live
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%,100% { opacity:1; transform: scale(1); }
          50%      { opacity:0.6; transform: scale(1.15); }
        }
        ::-webkit-scrollbar { height: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 2px; }
      `}</style>
    </div>
  )
}